import { createFileRoute } from '@tanstack/react-router';
import CallHistoryPage from '@/pages/calls/history/CallHistoryPage';
import { callHistorySearchSchema } from '@/pages/calls/history/search-schema';

export const Route = createFileRoute('/_authenticated/calls/')({
  component: CallHistoryPage,
  validateSearch: callHistorySearchSchema,
});
